import styled from 'styled-components';

export const LabelWrapper = styled('div')`
  margin-top: -${({ theme }) => theme.x3spacePx}px;
`;

interface Props {
  color: string;
}

export const Row = styled('tr')<Props>`
  color: ${({ color }) => color};
  &:first-child {
    td {
      ${({ theme }) => theme.typography.smallStrong};
    }
  }
`;
